import { convertDate, convertDateAsString } from "@_common/date-helpers";
import { QueryRequestHelper, QueryRequestHelperShowFalse } from "@_common/query-request-helper";
import NoAccessPage from "@components/common/NoAccess";
import RightMenuHeaders from "@components/common/RightMenuHeaders";
import DashboardLayout from "@layouts/dashboard/dashboard-layout";
import { getValue } from "@utils/lodash";
import MenuRepositorySvgComponent from "../../../../assets/svg-components/left-menu/menurepo";
import React, { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { toast } from "react-toastify";
import { getSpecificCategoryLawById } from "@_common/global-apis";
import { getCheckpointReleaseVendor } from "@services/checkpoint.service";
import qs from "query-string";
import Loader from "@components/common/Loader";
import ScrollableReactTable from "@components/ScrollableDatatable";
import CheckpointMasterNotfound from "@components/Page-Not-Found/checkpoint-master-not-found";
import FooterWrapper from "@components/common/FooterWrapper";
import { CellProps } from "react-table";
import SubmenuArrowDownSvgComponent from "../../../../assets/svg-components/left-menu/submenu-arrow-down";
import { formatText } from "@_common/format-text";
import FilterSearchDropdown from "@_common/FilterSearchDropdown";
import InputField from "@_common/InputRuleFeild";
import { downloadVendorComplianceAuditScore, downloadVendorComplianceMaster, downloadVendorWiseAuditScore, exportVendorComplianceMaster, getManageAuditScoreFilter, getVendorFilterLegislation, getVendorFilterLocation } from "@services/audit.service";
import SearchableDropdownSelect from "@_common/SearchableDropdown";
import { getVendorFilterLocationList } from "@services/vendors.service";
import { handleDownloadOnClick } from "@_common/downloadfile";
import { DownloadTypeEnum } from "@utils/general.enum";

export default function VendorComplianceRepositoryMaster(props: any) {
  let navigate = useNavigate();
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());


  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */
  const [isLoading, setIsLoading] = React.useState(true);
  const [list, setList] = React.useState<[]>([]);
  const [date, setDate] = useState<Date | null>(null);
  const [selectedIDs, setSelectedIDs] = useState<any>([]);
  const [check, setCheck] = useState(false);
  const [filteredLocations, setFilteredLocations] = useState([]);
  const [filteredLegislation, setFilteredLegislation] = useState([]);
  const [filteredVendorList, setFilteredVendorList] = useState([]);

  const [isFilterVisible, setFilterVisibility] = React.useState(false);

  const [filters, setFilters] = useState({
    location: "",
    legislation: "",
    vendor_id: ""
  });


  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                             */
  /* -------------------------------------------------------------------------- */
  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length === 0 && props.permissionAPITriggered) {
      getData();
      setDate(new Date());
      getRegionsList("", "");
      getGroupsList("", "", "");
      getStatesList("", "", "", "");
      getCitiesList("", "", "", "", "");
      getLocationsList("","","","","","");
      getVendorList("","","","","","","");
      getAuditCheckpointList("","","","","","","","")
      getAuditTypeList("","","","","","","","","");
    }
  }, [props.permissionAPITriggered]);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length > 0 && props.permissionAPITriggered) {
      getData();
      getRegionsList("", "");
      // getGroupsList("", "", "");
      // getStatesList("", "", "", "");
      // getCitiesList("", "", "", "", "");
      // getLocationsList("","","","","","");
      // getVendorList("","","","","","","");
      // getAuditCheckpointList("","","","","","","","")
      // getAuditTypeList("","","","","","","","","");


      // if (params.date) {
      //   setDate(new Date(params.date));
      // } else {
      //   setDate(new Date());
      // }

    // Updated date handling logic
    if (params.date) {
      // If full date is provided
      setDate(new Date(params.date));
    } else if (params.month && params.year) {
      // If month and year are provided separately
      // Note: Month in JavaScript is 0-based, so we subtract 1 from the month
      const monthNum = parseInt(params.month) - 1;
      const yearNum = parseInt(params.year);
      setDate(new Date(yearNum, monthNum, 1));
    } else {
      // Default to current date if no date parameters are provided
      setDate(new Date());
    }


      if (params.page_no) {
        setPage_no(parseInt(params.page_no));
      }
      if (params.limit) {
        setLimit(parseInt(params.limit));
      }

      if (params.search_text) {
        setSearchInput(params.search_text);
        setShowSearchTextbox(true);
      }

      //-----------------region & group-----------------//
      if (getValue(params, `region_id`, "")) {
        getRegionsList("", getValue(params, `region_id`, ""));
        getGroupsList(
          "",
          getValue(params, `region_id`, ""),
          getValue(params, `group_id`, "")
        );
      } else {
        getRegionsList("", getValue(params, `region_id`, ""));
      }

      //-----------------state-----------------//

      if (getValue(params, `group_id`, "")) {
        getStatesList(
          "",
          getValue(params, `region_id`, ""),
          getValue(params, `group_id`, ""),
          getValue(params, `state_id`, "")
        );
      }

      //-----------------city-----------------//

      if (getValue(params, `state_id`, "")) {
        getCitiesList(
          "",
          getValue(params, `region_id`, ""),
          getValue(params, `group_id`, ""),
          getValue(params, `state_id`, ""),
          getValue(params, `city_id`, "")
        );
      }

      //-----------------location-----------------//
      if (getValue(params, `group_id`, "")) {
        getLocationsList(
          "",
          getValue(params, `region_id`, ""),
          getValue(params, `group_id`, ""),
          getValue(params, `state_id`, ""),
          getValue(params, `city_id`, ""),
          getValue(params, `location_id`, "")
        );
      }
      //-----------------vendor-----------------//
      if (getValue(params, `location_id`, "")) {
        getVendorList(
          "",
          getValue(params, `region_id`, ""),
          getValue(params, `group_id`, ""),
          getValue(request, `state_id`, ""),
          getValue(request, `city_id`, ""),
          getValue(params, `location_id`, ""),
          getValue(params, `vendor_id`, "")
        );
      }

      //-----------------audit Checkpoint Id-----------------//
      if (getValue(params, `vendor_id`, "")) {
        getAuditCheckpointList(
          "",
          getValue(params, `region_id`, ""),
          getValue(params, `group_id`, ""),
          getValue(request, `state_id`, ""),
          getValue(request, `city_id`, ""),
          getValue(params, `location_id`, ""),
          getValue(params, `vendor_id`, ""),
          getValue(params, `audit_checkpoint_id`, "")
        )
      }

       //-----------------audit type-----------------//
       if (getValue(params, `audit_checkpoint_id`, "")) {
        getAuditTypeList(
          "",
          getValue(params, `region_id`, ""),
          getValue(params, `group_id`, ""),
          getValue(request, `state_id`, ""),
          getValue(request, `city_id`, ""),
          getValue(params, `location_id`, ""),
          getValue(params, `vendor_id`, ""),
          getValue(params, `audit_checkpoint_id`, ""),
          getValue(params, `audit_type`, ""),
        );
      }

      setRequest({
        ...request,
        region_id: getValue(params, `region_id`, ""),
        group_id: getValue(params, `group_id`, ""),
        state_id: getValue(params, `state_id`, ""),
        city_id: getValue(params, `city_id`, ""),
        location_id: getValue(params, `location_id`, ""),
        vendor_id: getValue(params, `vendor_id`, ""),
        audit_type: getValue(params, `audit_type`, ""),
        audit_checkpoint_id: getValue(params, `audit_checkpoint_id`, ""),
      });
      if (getValue(params, `region_id`, "")) {
        setFilterVisibility(true);
      }
    }
  }, [window.location.href, props.permissionAPITriggered]);

  console.log(date, "===Date===>")

  /* -------------------------------------------------------------------------- */
  /*                               API Section                             */
  /* -------------------------------------------------------------------------- */
  console.log(params, "---PArams---");
  const getData = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();

    let payload: any = {
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: params.limit ? parseInt(params.limit) : limit,
      search_text: params.search_text,
      // status: "active",
      sort_by: params.sort_by,
      country_id: getValue(params, `country_id`, ""),
      state_id: getValue(params, `state_id`, ""),
      city_id: getValue(params, `city_id`, ""),
      category_of_law_id: await getSpecificCategoryLawById(
        getValue(params, `category_of_law_id`, "")
      ),
      legislation_id: getValue(params, `legislation_id`, ""),
      // month: params.date
      //   ? params.date.split("-")[1]
      //   : date
      //   ? moment(date).format("MM")
      //   : moment(dates).format("MM"),
      // year: params.date
      //   ? params.date.split("-")[0]
      //   : date
      //   ? moment(date).format("YYYY")
      //   : moment(dates).format("YYYY"),


      month: params.month
        ? params.month // Use `month` from URL if present
        : params.date
        ? params.date.split("-")[1] // Extract month from `date`
        : date
        ? moment(date).format("MM") // Fallback to `date` or `dates`
        : moment(dates).format("MM"),
    
      year: params.year
        ? params.year // Use `year` from URL if present
        : params.date
        ? params.date.split("-")[0] // Extract year from `date`
        : date
        ? moment(date).format("YYYY") // Fallback to `date` or `dates`
        : moment(dates).format("YYYY"),
      status: params.status,
        region_id: params.region_id,  
        group_id: params.group_id,  
        location_id: params.location_id,  
        upload_status: params.update_status,
        vendor_id: params.vendor_id,
        audit_status: params.audit_type ? params.audit_type : params.audit_status,
        legislation_rule_id: params.audit_checkpoint_id,
        // audit_status: params.audit_status,
        event_text: params.event_text,
        category_of_law_text: params.category_of_law_text,
        is_active: true,
        is_redirect: true,
      };
      if (params.is_submitted !== undefined) {
        payload.is_submitted = params.is_submitted === "1"
          ? true
          : params.is_submitted === "2"
          ? false
          : undefined;
      }
  
      // Remove `is_submitted` if it ends up being `undefined`
      if (payload.is_submitted === undefined) {
        delete payload.is_submitted;
      }
  
    let queryRequest = QueryRequestHelperShowFalse(payload);
    try {
      setIsLoading(true);
      let resp = await getCheckpointReleaseVendor(queryRequest);
      if (resp) {
        setList(
          getValue(resp, `data.vendors_checkpoint`, []).map((item: object) => ({
            ...item,
            checkpoint_id: getValue(item, `checkpoint.checkpoint_id`, ""),
            category: getValue(item, `checkpoint.category_of_law.text`, ""),
            location_name: getValue(item, `location.location_name`, ""),
            region_name: getValue(item, `location.region.text`, ""),
            group_name: getValue(item, `location.group.group_name`, ""),
            legislation_rule: getValue(item, `checkpoint.legislation_rule.rule_name`, ""),
            recent_comments: getValue(item, `recent_comment.comments`, ""),
            events: getValue(item, `checkpoint.events.text`, ""),
            vendor_name: getValue(item, `vendor.vendor_name`, ""),
            status: getValue(item, `is_active`, false) ? "Active" : "Inactive",
            created_date: moment(getValue(item, `created_at`, "")).format(
              "DD MMM YYYY, hh:mm a"
            ),
            // audit_date : moment(getValue(item, `audited_at`, "")).format(
            //   "DD MMM YYYY"
            // ),
            audit_date: getValue(item, `audited_at`, "") 
            ? moment(getValue(item, `audited_at`, "")).format("DD MMM YYYY") 
            : " ",
            compliance_activity: getValue(
              item,
              `checkpoint.compliance_activity`,
              ""
            ),
            // audit_status: formatText(getValue(item, `audit_status`, "")),
            audit_status: (
              <div
                style={{
                  color:
                  getValue(item, `audit_status`, "") === "NON_COMPLIED"
                    ? "#d7242e" // Red
                    : getValue(item, `audit_status`, "") === "COMPLIED"
                    ? "#28a745" // Green
                    : getValue(item, `audit_status`, "") === "NOT_APPLICABLE"
                    ? "#007bff" // Blue
                    : getValue(item, `audit_status`, "") === "PENDING_AUDIT"
                    ? "#ffa500" // Orange
                    : getValue(item, `audit_status`, "") === "NOT_SUBMITTED"
                    ? "#808080" // Grey
                    : "", // Default color
            
                }}
              >
                {formatText(getValue(item, `audit_status`, ""))}
              </div>
            ),
        
            compliance_rule : getValue(
              item,
              `checkpoint.legislation_rule.rule_name`,
              ""
            ),
            legislation: getValue(item, `checkpoint.legislation.legislation_name`, ""),
          }))
        );
        setTotalCount(getValue(resp, `data.pagination.total`, 0));
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };


  /* -------------------------------------------------------------------------- */
  /*                               Pagination section                           */
  /* -------------------------------------------------------------------------- */

  const [totalCount, setTotalCount] = useState(0);
  const [limit, setLimit] = useState(100);
  const [page_no, setPage_no] = useState(1);

  const handleChangePagination = (page_no: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload = {
      ...params,
      page_no: page_no,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const handleChangeLimit = (limit: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      limit: limit,
      page_no: "1",
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  /* -------------------------------------------------------------------------- */
  /*                               Sub Header Code section                               */
  /* -------------------------------------------------------------------------- */
  const [showSearchTextbox, setShowSearchTextbox] = useState(false);
  const [search_text, setSearchInput] = useState<any>("");

  const toggleSearch = () => {
    setShowSearchTextbox((prevState) => !prevState);
  };
  const toggleSearchClose = () => {
    setSearchInput("");
    toggleSearch();
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (params.search_text) {
      delete params.search_text;
      let payload: any = { ...params };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
      getData();
    }
  };

  const handleChangeSearch = async (e: any) => {
    setSearchInput(e.target.value);
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      page_no: 1,
      search_text: e.target.value,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    if (!e.target.value) {
      getData();
    }
  };

  //   Sub Header Code
  const handleSubmitDate = () => {
    let dates = moment(date).format("YYYY-MM-DD");
    if (dates && dates !== "Invalid date") {
      let payload: any = {
        date: dates,
      };
      // removing null values
      Object.keys(payload).forEach((key) => {
        if (!payload[key] || payload[key] === undefined) {
          delete payload[key];
        }
      });
      let queryRequest = qs.stringify(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    } else {
      toast.error("Please select date");
    }
  };

  //Table Section
  const rowClick = (obj: object) => {
    // console.log(getValue(obj,`original`,''))
    // navigate(`/support/detail/${getValue(obj,`original.id`,'')}`)
    delete params["page_no"];
    let payload: any = {
      ...params,
    };
    let queryRequest = QueryRequestHelper(payload);
    if (getValue(obj, `original.id`, "")) {
      navigate(
        `/repository/vendor-compliance/master/task-details/${getValue(
          obj,
          `original.id`,
          ""
        )}/${getValue(obj, `original.checkpoint.id`, "")}?${queryRequest}`
      );
    } else {
      toast.error(" ID not available");
    }
  };
  const getTrProps = (rowInfo: any) => {
    if (getValue(rowInfo, `id`, "")) {
      return {
        style: {
          //   background:  'red',
          //   color: 'black'
        },
      };
    }
    return {};
  };
  const getTableState = (value: object) => {
    let selectedIndexList = Object.keys(
      getValue(value, `selectedRowIds`, {})
    ).map((item) => parseInt(item));
    let selectedIds =
      list.length > 0
        ? list.filter((_item: object, index: number) =>
            selectedIndexList.includes(index)
          )
        : [];
    if (selectedIds.length > 0) {
      setSelectedIDs(
        selectedIds.map((item: object) => getValue(item, `id`, ""))
      );
    } else {
      setSelectedIDs([]);
    }
  };

  const columns = React.useMemo(
    () => [
      // {
      //   Header: "Checkpoint ID",
      //   accessor: "checkpoint_id",
      //   width: 140,
      // },
      // {
      //   Header: "Task ID",
      //   accessor: "task_id",
      //   width: 140,
      // },
      {
        Header: "Region",
        accessor: "region_name",
        width: 80,
      },

      {
        Header: "Account",
        accessor: "group_name",
        width: 120,
      },
      {
        Header: "Site",
        accessor: "location_name",
        width: 120,
      },
      {
        Header: "Vendor",
        accessor: "vendor_name",
        width: 100,
      },
      {
        Header: "Title",
        accessor: "legislation_rule",
        width: 150,
      },
      {
        Header: "Risk",
        accessor: "events",
        width: 150,
      },
      // {
      //   Header: () => (
      //     <div>
      //       <strong style={{ fontWeight: "bold" }}>Act</strong>
      //       <br />
      //       <span>Details</span>
      //     </div>
      //   ),
      //   accessor: "act",
      //   width: 300,
      //   Cell: ({ row }:any) => (
      //     <div>
      //       <strong>{row.original.checkpoint.legislation.legislation_name}</strong>
      //       <br />
      //       <span>{row.original.checkpoint.compliance_activity}</span>
      //     </div>
      //   ),
      // },
     
      // {
      //   Header: "Audit Checkpoint",
      //   accessor: "compliance_rule",
      //   width: 200,
      // },
      {
        Header: "Audit Status",
        width: 100,
        accessor: "audit_status",
        // Cell: ({ row }: { row: any }) => {
        //   const auditStatus = getValue(row.original, "audit_status", "");
      
        //   return (
        //     <span
        //       style={{
        //         color: auditStatus === "NON_COMPLIED" ? "#d7242e" : "",
        //       }}
        //     >
        //       {auditStatus}
        //     </span>
        //   );
        // },
      },

      // {
      //   Header: "Status",
      //   accessor: "status",
      //   width: 100,
      // },
      {
        Header: "Audit Comments",
        accessor: "recent_comments",
        width: 200,
      },
      {
        Header: "Audit Date",
        accessor: "audit_date",
        width: 150,
      },
      // {
      //   Header: "Legislation",
      //   accessor: "legislation",
      //   width: 200,
      // },
      // {
      //   Header: "Activity",
      //   accessor: "compliance_activity",
      //   width: 350,
      //   Cell: ({ row }: CellProps<any>) => {
      //     const complianceActivity = getValue(
      //       row.original,
      //       `compliance_activity`,
      //       ""
      //     );
      
      //     const maxCharCount = 100;
      //     const [showFullContent, setShowFullContent] = useState(false);
      
      //     const toggleContent = (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
      //       e.stopPropagation();
      //       setShowFullContent(!showFullContent);
      //     };
      
      //     const truncatedContent = complianceActivity
      //       ? complianceActivity.slice(0, maxCharCount)
      //       : "";

      //     return (
      //       <div>
      //         {showFullContent ? complianceActivity : truncatedContent}
      //         {getValue(complianceActivity, `length`, 0) > maxCharCount && (
      //           <span onClick={toggleContent}>
      //             {showFullContent ? <span style={{color:"#276ef1"}}> View less <span style={{ transform: "rotate(180deg)", display: "inline-block"}}> <SubmenuArrowDownSvgComponent color="#276ef1" /> </span></span> : <span> ... <span style={{color:"#276ef1"}}>View more <SubmenuArrowDownSvgComponent color="#276ef1" /> </span></span>}
      //           </span>
      //         )}
      //       </div>
      //     );
      //   }
      // },
      // {
      //   Header: "Added On",
      //   accessor: "created_date",
      //   width: 150,
      // },
     

    ],
    []
  );

  /* ----------Module Filter ---------------------------------*/
  const [searchLoading1, setSearchLoading1] = useState(false);
  const getFilterLocations = async (id: string, value: string) => {
    let payload: any = {
      vendor_id: id,
      search_text: value,
      page_no: 1,
      page_size: 10,
    };
    let queryRequest = QueryRequestHelper(payload);
    setSearchLoading1(true);
    try {
      let resp = await getVendorFilterLocationList(queryRequest);
      if (resp) {
        setFilteredLocations(
          getValue(resp, `data.vendors[${0}].locations`, []).map((item: any) => ({
            ...item,
            id: getValue(item, `id`, ""),
            value: getValue(item, `location_name`, ""),
            label: getValue(item, `location_name`, ""),
          }))
        );
        setSearchLoading1(false);
      } else {
        setSearchLoading1(false);
      }
    } catch (error) {
      setSearchLoading1(false);
    }
  };

  const getFilterLegislations = async (id: string, value: string) => {
    let payload: any = {
      legislation_id: id,
      search_text: value,
      page_no: 1,
      page_size: 10,
    };
    let queryRequest = QueryRequestHelper(payload);

    try {
      setSearchLoading(true);
      let resp = await getVendorFilterLegislation(queryRequest);
      if (resp) {
        setFilteredLegislation(
          getValue(resp, `data`, []).map((item: any) => ({
            ...item,
            value: getValue(item, `legislation_name`, ""),
            label: getValue(item, `legislation_name`, ""),
          }))
        );
        setSearchLoading(false);
      } else {
        setSearchLoading(false);
      }
    } catch (error) {
      setSearchLoading(false);
    }
  };
  const [complianceStatusList] = useState([
    { value: "NOT_SUBMITTED", label: "Not Submitted" },
    { value: "PENDING_AUDIT", label: "Pending Audit" },
    { value: "COMPLIED", label: "Complied" },
    { value: "NON_COMPLIED", label: "Non Complied" },
    { value: "PARTIALLY_COMPLIED", label: "Partially Complied" },
    { value: "NOT_APPLICABLE", label: "Not Applicable" },
    { value: "SEND_BACK_TO_VENDOR", label: "Send Back to Vendor" },
  ]);

  const handleChangeFilter = (name: string, value: string) => {
    if (value) {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      let payload = {
        ...params,
        [name]: value,
        page_no: 1,
      };
      setFilters({
        ...filters,
        [name]: value,
      });
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    } else {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      let payload = {
        ...params,
        [name]: "",
        page_no: 1,
      };
      setFilters({
        ...filters,
        [name]: "",
      });
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                      New Location Search Section                           */
  /* -------------------------------------------------------------------------- */
  const [searchLoading, setSearchLoading] = useState(false);

  const handleTriggerLocation = async (value: string) => {
    if (!value) {
      setFilters({
        ...filters,
        location: "",
      });
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      delete params.location_id;
      let payload = {
        ...params,
        page_no: 1,
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    } else {
      setFilters({
        ...filters,
        location: value,
      });
      getFilterLocations("", value);
    }
  };
  const handleTriggerLegislation = async (value: string) => {
    if (!value) {
      setFilters({
        ...filters,
        legislation: "",
      });
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      delete params.legislation_id;
      let payload = {
        ...params,
        page_no: 1,
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    } else {
      setFilters({
        ...filters,
        legislation: value,
      });
      getFilterLegislations("", value);
    }
  };

  // const handleTriggerVendorList = async (value: string) => {
  //   if (!value) {
  //     setFilters({
  //       ...filters,
  //       vendor_id: "",
  //     });
  //     const urlSearchParams = new URLSearchParams(window.location.search);
  //     const params = Object.fromEntries(urlSearchParams.entries());
  //     delete params.vendor_id;
  //     let payload = {
  //       ...params,
  //       page_no: 1,
  //     };
  //     let queryRequest = QueryRequestHelper(payload);
  //     navigate(`${window.location.pathname}?${queryRequest}`);
  //   } else {
  //     setFilters({
  //       ...filters,
  //       vendor_id: value,
  //     });
  //     getFilterLocations("", value);
  //   }
  // };

  const handleTriggerVendorList = async (value: string) => {
    if (!value) {
      setFilters({
        ...filters,
        vendor_id: "",
      });
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      delete params.vendor_id;
      let payload = {
        ...params,
        page_no: 1,
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    } else {
      setFilters({
        ...filters,
        vendor_id: value,
      });
      // getVendorList("",value);
    }
  };

  const urlParamsFun = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let request = QueryRequestHelper({ ...params });
    return request;
  };

  const mainQueryRequest = useMemo(() => urlParamsFun(), [
    window.location.href,
  ]);
  const handleNavigateFilter = (type: string) => {
    let payload: any = {
      ...params,
      page_no: 1,
      audit_status: type,
    };
    // removing null values
    Object.keys(payload).forEach((key) => {
      if (!payload[key] || payload[key] === undefined) {
        delete payload[key];
      }
    });
    let queryRequest = qs.stringify(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  // const [vendorsList, setvendorsList] = useState([]);
  // const [vendorLoading, setvendorLoading] = useState(false);
  // const getVendorList = async (
  //   id: string,
  //   search_text: string,
  // ) => {
  //   const urlSearchParams = new URLSearchParams(window.location.search);
  //   const params = Object.fromEntries(urlSearchParams.entries());
  //   let dates = date ? date : new Date();
  //   try {
  //     let payload = {
  //       vendor_id: id,
  //       search_text: search_text,

  //     };
  //     setvendorLoading(true);
  //     let queryRequest = QueryRequestHelper(payload);
  //     let resp = await getVendorFilterLocationList(queryRequest)
  //     if (resp) {
  //       setvendorsList(
  //         getValue(resp, `data.vendors`, []).map((item: object) => ({
  //           ...item,
  //           id: getValue(item, `id`, ""),
  //           label: getValue(item, `vendor_name`, ""),
  //           value: getValue(item, `vendor_name`, ""),
  //         }))
  //       );
  //       setvendorLoading(false);
  //     } else {
  //       setvendorLoading(false);
  //     }
  //   } catch (error) {
  //     setvendorLoading(false);
  //   }
  // };



  /* -------------------------------------------------------------------------- */
  /*                        smart Filter section                                */
  /* -------------------------------------------------------------------------- */
  const [request, setRequest] = useState<any>({
    state_id: "",
    city_id: "",
    region_id: "",
    group_id: "",
    location_id: "",
    vendor_id: "",
    audit_checkpoint_id: "",
    audit_type: "",
  });

  const reset = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      page_no: params.page_no,
      search_text: getValue(params, `search_text`, ""),
      limit: getValue(params, `limit`, ""),
    };
    setRequest({
      ...request,
      state_id: "",
      city_id: "",
      region_id: "",
      group_id: "",
      location_id: "",
      vendor_id: "",
      audit_checkpoint_id: "",
      audit_type: "",
    });
    setGroupsList([]);
    setStateList([]);
    setCityList([]);
    setlocationsList([]);
    setvendorsList([]);
    //  setFilterVisibility(false);
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    getData();
    // getRegionsList("", getValue(params, `region_id`, ""));
    getRegionsList("", "");
    getGroupsList("", "", "");
    getStatesList("", "", "", "");
    getCitiesList("", "", "", "", "");
    getLocationsList("","","","","","");
    getVendorList("","","","","","","");
    getAuditTypeList("","","","","","","","","");
  };

  // /* -------------------------------------------------------------------------- */
  // /*                    smart Filter API section                                */
  // /* -------------------------------------------------------------------------- */

  // const [regionList, setRegionList] = useState([]);
  // const [regionLoading, setRegionLoading] = useState(false);

  // const getRegionsList = async (search_text: string, id: string) => {
  //   const urlSearchParams = new URLSearchParams(window.location.search);
  //   const params = Object.fromEntries(urlSearchParams.entries());
  //   let dates = date ? date : new Date();
  //   try {
  //     let payload = {
  //       month: params.date
  //         ? params.date.split("-")[1]
  //         : date
  //         ? moment(date).format("MM")
  //         : moment(dates).format("MM"),
  //       year: params.date
  //         ? params.date.split("-")[0]
  //         : date
  //         ? moment(date).format("YYYY")
  //         : moment(dates).format("YYYY"),
  //       type: "REGION",
  //       search_text: search_text,
  //       region_id: id,
  //     };
  //     setRegionLoading(true);
  //     let queryRequest = QueryRequestHelper(payload);
  //     let resp = await getManageAuditScoreFilter(queryRequest);
  //     if (resp) {
  //       setRegionList(
  //         getValue(resp, `data`, []).map((item: object) => ({
  //           ...item,
  //           id: getValue(item, `region_id`, ""),
  //           label: getValue(item, `region_name`, ""),
  //           value: getValue(item, `region_name`, ""),
  //         }))
  //       );
  //       setRegionLoading(false);
  //     } else {
  //       setRegionLoading(false);
  //     }
  //   } catch (error) {
  //     setRegionLoading(false);
  //   }
  // };

  // const [groupsList, setGroupsList] = useState([]);
  // const [groupLoading, setGroupLoading] = useState(false);
  // const getGroupsList = async (
  //   search_text: string,
  //   region_id: string,
  //   id: string
  // ) => {
  //   const urlSearchParams = new URLSearchParams(window.location.search);
  //   const params = Object.fromEntries(urlSearchParams.entries());
  //   let dates = date ? date : new Date();
  //   try {
  //     let payload = {
  //       month: params.date
  //         ? params.date.split("-")[1]
  //         : date
  //         ? moment(date).format("MM")
  //         : moment(dates).format("MM"),
  //       year: params.date
  //         ? params.date.split("-")[0]
  //         : date
  //         ? moment(date).format("YYYY")
  //         : moment(dates).format("YYYY"),
  //       region_id: region_id,
  //       type: "GROUP",
  //       search_text: search_text,
  //       group_id: id,
  //     };
  //     setGroupLoading(true);
  //     let queryRequest = QueryRequestHelper(payload);
  //     let resp = await getManageAuditScoreFilter(queryRequest);
  //     if (resp) {
  //       setGroupsList(
  //         getValue(resp, `data`, []).map((item: object) => ({
  //           ...item,
  //           id: getValue(item, `group_id`, ""),
  //           label: getValue(item, `group_name`, ""),
  //           value: getValue(item, `group_name`, ""),
  //         }))
  //       );
  //       setGroupLoading(false);
  //     } else {
  //       setGroupLoading(false);
  //     }
  //   } catch (error) {
  //     setGroupLoading(false);
  //   }
  // };


  // const [locationsList, setlocationsList] = useState([]);
  // const [locationLoading, setLocationLoading] = useState(false);
  // const getLocationsList = async (
  //   search_text: string,
  //   region_id: string,
  //   group_id: string,
  //   // state_id: string,
  //   // city_id: string,
  //   id: string
  // ) => {
  //   const urlSearchParams = new URLSearchParams(window.location.search);
  //   const params = Object.fromEntries(urlSearchParams.entries());
  //   let dates = date ? date : new Date();
  //   try {
  //     let payload = {
  //       month: params.date
  //         ? params.date.split("-")[1]
  //         : date
  //         ? moment(date).format("MM")
  //         : moment(dates).format("MM"),
  //       year: params.date
  //         ? params.date.split("-")[0]
  //         : date
  //         ? moment(date).format("YYYY")
  //         : moment(dates).format("YYYY"),
  //       region_id: region_id,
  //       group_id: group_id,
  //       type: "LOCATION",
  //       search_text: search_text,
  //       // state_id: state_id,
  //       // city_id: city_id,
  //       location_id: id,
  //     };
  //     setLocationLoading(true);
  //     let queryRequest = QueryRequestHelper(payload);
  //     let resp = await getManageAuditScoreFilter(queryRequest);
  //     if (resp) {
  //       setlocationsList(
  //         getValue(resp, `data`, []).map((item: object) => ({
  //           ...item,
  //           id: getValue(item, `location_id`, ""),
  //           label: getValue(item, `location_name`, ""),
  //           value: getValue(item, `location_name`, ""),
  //         }))
  //       );
  //       setLocationLoading(false);
  //     } else {
  //       setLocationLoading(false);
  //     }
  //   } catch (error) {
  //     setLocationLoading(false);
  //   }
  // };

  // const [vendorsList, setvendorsList] = useState([]);
  // const [vendorLoading, setvendorLoading] = useState(false);
  // const getVendorList = async (
  //   search_text: string,
  //   region_id: string,
  //   group_id: string,
  //   // state_id: string,
  //   // city_id: string,
  //   location_id: string,
  //   id: string
  // ) => {
  //   const urlSearchParams = new URLSearchParams(window.location.search);
  //   const params = Object.fromEntries(urlSearchParams.entries());
  //   let dates = date ? date : new Date();
  //   try {
  //     let payload = {
  //       month: params.date
  //         ? params.date.split("-")[1]
  //         : date
  //         ? moment(date).format("MM")
  //         : moment(dates).format("MM"),
  //       year: params.date
  //         ? params.date.split("-")[0]
  //         : date
  //         ? moment(date).format("YYYY")
  //         : moment(dates).format("YYYY"),
  //       region_id: region_id,
  //       group_id: group_id,
  //       // state_id: state_id,
  //       // city_id: city_id,
  //       location_id: location_id,
  //       type: "VENDOR",
  //       search_text: search_text,
  //       vendor_id: id,
  //     };
  //     setvendorLoading(true);
  //     let queryRequest = QueryRequestHelper(payload);
  //     let resp = await getManageAuditScoreFilter(queryRequest);
  //     if (resp) {
  //       setvendorsList(
  //         getValue(resp, `data`, []).map((item: object) => ({
  //           ...item,
  //           id: getValue(item, `vendor_id`, ""),
  //           label: getValue(item, `vendor_name`, ""),
  //           value: getValue(item, `vendor_name`, ""),
  //         }))
  //       );
  //       setvendorLoading(false);
  //     } else {
  //       setvendorLoading(false);
  //     }
  //   } catch (error) {
  //     setvendorLoading(false);
  //   }
  // };


  /* -------------------------------------------------------------------------- */
  /*                    smart Filter API section                                */
  /* -------------------------------------------------------------------------- */

  const [regionList, setRegionList] = useState([]);
  const [regionLoading, setRegionLoading] = useState(false);

  const getRegionsList = async (search_text: string, id: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    try {
      let payload = {
        month: params.date
          ? params.date.split("-")[1]
          : date
          ? moment(date).format("MM")
          : moment(dates).format("MM"),
        year: params.date
          ? params.date.split("-")[0]
          : date
          ? moment(date).format("YYYY")
          : moment(dates).format("YYYY"),
        type: "REGION",
        search_text: search_text,
        region_id: id,
        page_size:  100,
        is_redirect: true,
      };
      setRegionLoading(true);
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getManageAuditScoreFilter(queryRequest);

      if(getValue(resp, `data`, []).length === 0 ) {
        throw "Error"
      }

      if (resp) {
        setRegionList(
          getValue(resp, `data.vendors_checkpoint`, []).map((item: object) => ({
            ...item,
            id: getValue(item, `region_id`, ""),
            label: getValue(item, `region_name`, ""),
            value: getValue(item, `region_name`, ""),
          }))
        );
        setRegionLoading(false);
      } else {
        setRegionLoading(false);
      }
    } catch (error) {
      toast.dismiss();
      setRegionLoading(false);
    }
  };

  const [groupsList, setGroupsList] = useState([]);
  const [groupLoading, setGroupLoading] = useState(false);
  const getGroupsList = async (
    search_text: string,
    region_id: string,
    id: string
  ) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    try {
      let payload = {
        month: params.date
          ? params.date.split("-")[1]
          : date
          ? moment(date).format("MM")
          : moment(dates).format("MM"),
        year: params.date
          ? params.date.split("-")[0]
          : date
          ? moment(date).format("YYYY")
          : moment(dates).format("YYYY"),
        region_id: region_id,
        type: "GROUP",
        search_text: search_text,
        group_id: id,
        page_size:  100,
        is_redirect: true,
      };
      setGroupLoading(true);
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getManageAuditScoreFilter(queryRequest);
      if (resp) {
        setGroupsList(
          getValue(resp, `data.vendors_checkpoint`, []).map((item: object) => ({
            ...item,
            id: getValue(item, `group_id`, ""),
            label: getValue(item, `group_name`, ""),
            value: getValue(item, `group_name`, ""),
          }))
        );
        setGroupLoading(false);
      } else {
        setGroupLoading(false);
      }
    } catch (error) {
      setGroupLoading(false);
    }
  };

  const [stateList, setStateList] = useState([]);
  const [stateLoading, setStateLoading] = useState(false);
  const getStatesList = async (
    search_text: string,
    region_id: string,
    group_id: string,
    id: string
  ) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    try {
      let payload = {
        month: params.date
          ? params.date.split("-")[1]
          : date
          ? moment(date).format("MM")
          : moment(dates).format("MM"),
        year: params.date
          ? params.date.split("-")[0]
          : date
          ? moment(date).format("YYYY")
          : moment(dates).format("YYYY"),
        region_id: region_id,
        group_id: group_id,
        type: "STATE",
        search_text: search_text,
        state_id: id,
        page_size:  100,
        is_redirect: true,
      };

      setStateLoading(true);
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getManageAuditScoreFilter(queryRequest);
      if (resp) {
        setStateList(
          getValue(resp, `data.vendors_checkpoint`, []).map((item: object) => ({
            ...item,
            id: getValue(item, `state_id`, ""),
            label: getValue(item, `state_name`, ""),
            value: getValue(item, `state_name`, ""),
          }))
        );
        setStateLoading(false);
      } else {
        setStateLoading(false);
      }
    } catch (error) {
      setStateLoading(false);
    }
  };

  const [cityList, setCityList] = useState([]);
  const [cityLoading, setCityLoading] = useState(false);
  const getCitiesList = async (
    search_text: string,
    region_id: string,
    group_id: string,
    state_id: string,
    id: string
  ) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    try {
      let payload = {
        month: params.date
          ? params.date.split("-")[1]
          : date
          ? moment(date).format("MM")
          : moment(dates).format("MM"),
        year: params.date
          ? params.date.split("-")[0]
          : date
          ? moment(date).format("YYYY")
          : moment(dates).format("YYYY"),
        region_id: region_id,
        group_id: group_id,
        type: "CITY",
        search_text: search_text,
        state_id: state_id,
        city_id: id,
        page_size:  100,
        is_redirect: true,
      };

      setCityLoading(true);
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getManageAuditScoreFilter(queryRequest);
      if (resp) {
        setCityList(
          getValue(resp, `data.vendors_checkpoint`, []).map((item: object) => ({
            ...item,
            id: getValue(item, `city_id`, ""),
            label: getValue(item, `city_name`, ""),
            value: getValue(item, `city_name`, ""),
          }))
        );
        setCityLoading(false);
      } else {
        setCityLoading(false);
      }
    } catch (error) {
      setCityLoading(false);
    }
  };


  const [locationsList, setlocationsList] = useState([]);
  const [locationLoading, setLocationLoading] = useState(false);
  const getLocationsList = async (
    search_text: string,
    region_id: string,
    group_id: string,
    state_id: string,
    city_id: string,
    id: string
  ) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    try {
      let payload = {
        month: params.date
          ? params.date.split("-")[1]
          : date
          ? moment(date).format("MM")
          : moment(dates).format("MM"),
        year: params.date
          ? params.date.split("-")[0]
          : date
          ? moment(date).format("YYYY")
          : moment(dates).format("YYYY"),
        region_id: region_id,
        group_id: group_id,
        type: "LOCATION",
        search_text: search_text,
        state_id: state_id,
        city_id: city_id,
        location_id: id,
        page_size:  100,
        is_redirect: true,
      };
      setLocationLoading(true);
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getManageAuditScoreFilter(queryRequest);
      if (resp) {
        setlocationsList(
          getValue(resp, `data.vendors_checkpoint`, []).map((item: object) => ({
            ...item,
            id: getValue(item, `location_id`, ""),
            label: getValue(item, `location_name`, ""),
            value: getValue(item, `location_name`, ""),
          }))
        );
        setLocationLoading(false);
      } else {
        setLocationLoading(false);
      }
    } catch (error) {
      setLocationLoading(false);
    }
  };

  const [vendorsList, setvendorsList] = useState([]);
  const [vendorLoading, setvendorLoading] = useState(false);
  const getVendorList = async (
    search_text: string,
    region_id: string,
    group_id: string,
    state_id: string,
    city_id: string,
    location_id: string,
    id: string
  ) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    try {
      let payload = {
        month: params.date
          ? params.date.split("-")[1]
          : date
          ? moment(date).format("MM")
          : moment(dates).format("MM"),
        year: params.date
          ? params.date.split("-")[0]
          : date
          ? moment(date).format("YYYY")
          : moment(dates).format("YYYY"),
        region_id: region_id,
        group_id: group_id,
        state_id: state_id,
        city_id: city_id,
        location_id: location_id,
        type: "VENDOR",
        search_text: search_text,
        vendor_id: id,
        page_size:  100,
        is_redirect: true,
      };
      setvendorLoading(true);
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getManageAuditScoreFilter(queryRequest);
      if (resp) {
        setvendorsList(
          getValue(resp, `data.vendors_checkpoint`, []).map((item: object) => ({
            ...item,
            id: getValue(item, `vendor_id`, ""),
            label: getValue(item, `vendor_name`, ""),
            value: getValue(item, `vendor_name`, ""),
          }))
        );
        setvendorLoading(false);
      } else {
        setvendorLoading(false);
      }
    } catch (error) {
      setvendorLoading(false);
    }
  };

  const [auditCheckpointList, setAuditCheckpointList] = useState([]);
  const [auditCheckpointLoading, setAuditCheckpointLoading] = useState(false);
  const getAuditCheckpointList = async (
    search_text: string,
    region_id: string,
    group_id: string,
    state_id: string,
    city_id: string,
    location_id: string,
    vendor_id: string,
    id: string
  ) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    try {
      let payload = {
        month: params.date
          ? params.date.split("-")[1]
          : date
          ? moment(date).format("MM")
          : moment(dates).format("MM"),
        year: params.date
          ? params.date.split("-")[0]
          : date
          ? moment(date).format("YYYY")
          : moment(dates).format("YYYY"),
        region_id: region_id,
        group_id: group_id,
        state_id: state_id,
        city_id: city_id,
        location_id: location_id,
        vendor_id: vendor_id,
        type: "AUDIT_CHECKPOINT",
        search_text: search_text,
        vendor_checkpoint_id: id,
        page_size:  100,
        is_redirect: true,
      };
      setAuditCheckpointLoading(true);
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getManageAuditScoreFilter(queryRequest);
      if (resp) {
        setAuditCheckpointList(
          getValue(resp, `data.vendors_checkpoint`, []).map((item: object) => ({
            ...item,
            id: getValue(item, `legislation_id`, ""),
            label: getValue(item, `legislation_rule`, ""),
            value: getValue(item, `legislation_rule`, ""),
          }))
        );
        setAuditCheckpointLoading(false);
      } else {
        setAuditCheckpointLoading(false);
      }
    } catch (error) {
      setAuditCheckpointLoading(false);
    }
  };

  const [auditTypeList, setAuditTypeList] = useState([]);
  const [auditTypeLoading, setAuditTypeLoading] = useState(false);
  const getAuditTypeList = async (
    search_text: string,
    region_id: string,
    group_id: string,
    state_id: string,
    city_id: string,
    location_id: string,
    vendor_id: string,
    audit_checkpoint_id: string,
    id: string
  ) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    try {
      let payload = {
        month: params.date
          ? params.date.split("-")[1]
          : date
          ? moment(date).format("MM")
          : moment(dates).format("MM"),
        year: params.date
          ? params.date.split("-")[0]
          : date
          ? moment(date).format("YYYY")
          : moment(dates).format("YYYY"),
        region_id: region_id,
        group_id: group_id,
        state_id: state_id,
        city_id: city_id,
        location_id: location_id,
        vendor_id: vendor_id,
        audit_checkpoint_id: audit_checkpoint_id,
        type: "AUDIT_TYPE",
        search_text: search_text,
        audit_type: id,
        page_size:  100,
        is_redirect: true,
      };
      setAuditTypeLoading(true);
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getManageAuditScoreFilter(queryRequest);
      if (resp) {
        setAuditTypeList(
          getValue(resp, `data.vendors_checkpoint`, []).map((item: object) => ({
            ...item,
            id: getValue(item, `audit_status`, ""),
            label: formatText(getValue(item, `audit_status`, "")),
            value: getValue(item, `audit_status`, ""),
          }))
        );
        setAuditTypeLoading(false);
      } else {
        setAuditTypeLoading(false);
      }
    } catch (error) {
      setAuditTypeLoading(false);
    }
    if (!search_text) {
      // setRequest({
      //   ...request,
      //   vendor_id: "",
      // });
    }
  };

  // const handleRemoveFilter = (name: string) => {
  //   if (name === "region_id") {
  //     setRequest({
  //       ...request,
  //       region_id: "",
  //       group_id: "",
  //       state_id: "",
  //       city_id: "",
  //       location_id: "",
  //       vendor_id: "",
  //       audit_type: "",
  //     });
  //     getRegionsList("", "");
  //     setGroupsList([]);
  //     setlocationsList([]);
  //     setvendorsList([]);
  //   }
  //   if (name === "group_id") {
  //     setRequest({
  //       ...request,
  //       group_id: "",
  //       location_id: "",
  //       vendor_id: "",
  //     });
  //     // getRegionsList("", "");
  //     getGroupsList("", getValue(request, `region_id`, ""), "");
  //     setlocationsList([]);
  //     setvendorsList([]);
  //   }

  //   if (name === "location_id") {
  //     setRequest({
  //       ...request,
  //       location_id: "",
  //       vendor_id: "",
  //     });

  //     getLocationsList(
  //       "",
  //       getValue(request, `region_id`, ""),
  //       getValue(request, `group_id`, ""),
  //       // getValue(request, `state_id`, ""),
  //       // getValue(request, `city_id`, ""),
  //       ""
  //     );
  //     setvendorsList([]);
  //   }
  //   if (name === "vendor_id") {
  //     setRequest({
  //       ...request,
  //       vendor_id: "",
  //       audit_type: "",
  //     });

  //     getVendorList(
  //       "",
  //       getValue(request, `region_id`, ""),
  //       getValue(request, `group_id`, ""),
  //       // getValue(request, `state_id`, ""),
  //       // getValue(request, `city_id`, ""),
  //       getValue(request, `location_id`, ""),
  //       ""
  //     );
  //   }
  // };


  // const handleSelectFilter = (id: any, name: string) => {
  //   if (name === "region_id") {
  //     getGroupsList("", id, "");
  //     setRequest({
  //       ...request,
  //       group_id: "",
  //       location_id: "",
  //       vendor_id: "",
  //     });
  //     setGroupsList([]);
  //     setlocationsList([]);
  //     setvendorsList([]);
  //   }
  //   if (name === "group_id") {
  //     getLocationsList(
  //       "",
  //       getValue(request, `region_id`, ""),
  //       id,
  //       // getValue(request, `group_id`, ""),
  //       // getValue(request, `state_id`, ""),
  //       // id,
  //       ""
  //     );
  //     setRequest({
  //       ...request,
  //       location_id: "",
  //       vendor_id: "",
  //     });
  //     setlocationsList([]);
  //     setvendorsList([]);
  //   }

  //   if (name === "location_id") {
  //     getVendorList(
  //       "",
  //       getValue(request, `region_id`, ""),
  //       getValue(request, `group_id`, ""),
  //       // getValue(request, `state_id`, ""),
  //       // getValue(request, `city_id`, ""),
  //       id,
  //       ""
  //     );
  //     setRequest({
  //       ...request,
  //       vendor_id: "",
  //     });
  //     setvendorsList([]);
  //   }

  //   setRequest({
  //     ...request,
  //     [name]: id,
  //   });
  // };

  const handleRemoveFilter = (name: string) => {
    if (name === "region_id") {
      setRequest({
        ...request,
        region_id: "",
        group_id: "",
        state_id: "",
        city_id: "",
        location_id: "",
        vendor_id: "",
        audit_checkpoint_id: "",
        audit_type: "",
      });
      getRegionsList("", "");
      setGroupsList([]);
      setStateList([]);
      setCityList([]);
      setlocationsList([]);
      setvendorsList([]);
      setAuditCheckpointList([]);
      setAuditTypeList([]);

    }
    if (name === "group_id") {
      setRequest({
        ...request,
        group_id: "",
        state_id: "",
        city_id: "",
        location_id: "",
        vendor_id: "",
        audit_checkpoint_id: "",
        audit_type: "",
      });
      // getRegionsList("", "");
      getGroupsList("", getValue(request, `region_id`, ""), "");
      setStateList([]);
      setCityList([]);
      setlocationsList([]);
      setvendorsList([]);
      setAuditCheckpointList([]);
      setAuditTypeList([]);
    }

    if (name === "state_id") {
      setRequest({
        ...request,
        state_id: "",
        city_id: "",
        location_id: "",
        vendor_id: "",
        audit_checkpoint_id: "",
        audit_type: "",
      });
      // getRegionsList("", "");
      getStatesList(
        "",
        getValue(request, `region_id`, ""),
        getValue(request, `group_id`, ""),
        ""
      );
      setCityList([]);
      setlocationsList([]);
      setvendorsList([]);
      setAuditCheckpointList([]);
      setAuditTypeList([]);
    }

    if (name === "city_id") {
      setRequest({
        ...request,
        city_id: "",
        location_id: "",
        vendor_id: "",
        audit_checkpoint_id: "",
        audit_type: "",
      });
      // getRegionsList("", "");
      getCitiesList(
        "",
        getValue(request, `region_id`, ""),
        getValue(request, `group_id`, ""),
        getValue(request, `state_id`, ""),
        ""
      );
      setlocationsList([]);
      setvendorsList([]);
      setAuditCheckpointList([]);
      setAuditTypeList([]);
    }

    if (name === "location_id") {
      setRequest({
        ...request,
        location_id: "",
        vendor_id: "",
        audit_checkpoint_id: "",
        audit_type: "",
      });
      // getRegionsList("", "");
      // getGroupsList("", getValue(request, `region_id`, ""), "");
      getLocationsList(
        "",
        getValue(request, `region_id`, ""),
        getValue(request, `group_id`, ""),
        getValue(request, `state_id`, ""),
        getValue(request, `city_id`, ""),
        ""
      );
      setvendorsList([]);
      setAuditCheckpointList([]);
      setAuditTypeList([]);
    }
    if (name === "vendor_id") {
      setRequest({
        ...request,
        vendor_id: "",
        audit_checkpoint_id: "",
        audit_type: "",
      });
      // getRegionsList("", "");
      // getGroupsList("", getValue(request, `region_id`, ""), "");
      // getLocationsList(
      //   "",
      //   getValue(request, `region_id`, ""),
      //   getValue(request, `group_id`, ""),
      //   ""
      // );
      getVendorList(
        "",
        getValue(request, `region_id`, ""),
        getValue(request, `group_id`, ""),
        getValue(request, `state_id`, ""),
        getValue(request, `city_id`, ""),
        getValue(request, `location_id`, ""),
        ""
      );
      setAuditCheckpointList([]);
      setAuditTypeList([]);
    }

    if (name === "audit_checkpoint_id") {
      setRequest({
        ...request,
        audit_checkpoint_id: "",
        audit_type:"",
      });

      getAuditCheckpointList(
        "",
        getValue(request, `region_id`, ""),
        getValue(request, `group_id`, ""),
        getValue(request, `state_id`, ""),
        getValue(request, `city_id`, ""),
        getValue(request, `location_id`, ""),
        getValue(request, `vendor_id`, ""),
        ""
      );
      setAuditTypeList([]);
    }

    if (name === "audit_type") {
      setRequest({
        ...request,
        audit_type: "",
      });
      getAuditTypeList(
        "",
        getValue(request, `region_id`, ""),
        getValue(request, `group_id`, ""),

        getValue(request, `state_id`, ""),
        getValue(request, `city_id`, ""),

        getValue(request, `location_id`, ""),
        getValue(request, `vendor_id`, ""),
        getValue(request, `audit_checkpoint_id`, ""),
        ""
      );
    }
    getGroupsList("", "", "");
    getStatesList("", "", "", "");
    getCitiesList("", "", "", "", "");
    getLocationsList("","","","","","");
    getVendorList("","","","","","","");
    getAuditTypeList("","","","","","","","","");
  };

  

  const handleSelectFilter = (id: any, name: string) => {
    if (name === "region_id") {
      getGroupsList("", id, "");
      setRequest({
        ...request,
        group_id: "",
        state_id: "",
        city_id: "",
        location_id: "",
        vendor_id: "",
        audit_checkpoint_id:"",
        audit_type: "",
      });
      setGroupsList([]);
      setStateList([]);
      setCityList([]);
      setlocationsList([]);
      setvendorsList([]);
      setAuditCheckpointList([]);
      setAuditTypeList([]);
    }
    if (name === "group_id") {
      getStatesList("", getValue(request, `region_id`, ""), id, "");
      setRequest({
        ...request,
        state_id: "",
        city_id: "",
        location_id: "",
        vendor_id: "",
        audit_checkpoint_id: "",
        audit_type: "",
      });
      setStateList([]);
      setCityList([]);
      setlocationsList([]);
      setvendorsList([]);
      setAuditCheckpointList([]);
      setAuditTypeList([]);
    }

    if (name === "state_id") {
      getCitiesList(
        "",
        getValue(request, `region_id`, ""),
        getValue(request, `group_id`, ""),
        id,
        ""
      );
      setRequest({
        ...request,
        city_id: "",
        location_id: "",
        vendor_id: "",
        audit_checkpoint_id: "",
        audit_type: "",
      });
      setCityList([]);
      setlocationsList([]);
      setvendorsList([]);
      setAuditCheckpointList([]);
      setAuditTypeList([]);

    }

    if (name === "city_id") {
      getLocationsList(
        "",
        getValue(request, `region_id`, ""),
        getValue(request, `group_id`, ""),
        getValue(request, `state_id`, ""),
        id,
        ""
      );
      setRequest({
        ...request,
        location_id: "",
        vendor_id: "",
        audit_checkpoint_id: "",
        audit_type: "",
      });
      setlocationsList([]);
      setvendorsList([]);
      setAuditCheckpointList([]);
      setAuditTypeList([]);

    }

    if (name === "location_id") {
      getVendorList(
        "",
        getValue(request, `region_id`, ""),
        getValue(request, `group_id`, ""),
        getValue(request, `state_id`, ""),
        getValue(request, `city_id`, ""),
        id,
        ""
      );
      setRequest({
        ...request,
        vendor_id: "",
        audit_checkpoint_id: "",
        audit_type: "",
      });
      setvendorsList([]);
      setAuditCheckpointList([]);
      setAuditTypeList([]);
    }

    if (name === "vendor_id") {
      // getAuditTypeList(
      //   "",
      //   getValue(request, `region_id`, ""),
      //   getValue(request, `group_id`, ""),
      //   getValue(request, `state_id`, ""),
      //   getValue(request, `city_id`, ""),
      //   getValue(request, `location_id`, ""),
      //   getValue(request, `audit_checkpoint_id`, ""),
      //   id,
      //   ""
      // );
      getAuditCheckpointList(
        "",
        getValue(request, `region_id`, ""),
        getValue(request, `group_id`, ""),
        getValue(request, `state_id`, ""),
        getValue(request, `city_id`, ""),
        getValue(request, `location_id`, ""),
        id,
        ""
      );
      setRequest({
        ...request,
        audit_checkpoint_id: "",
        audit_type: "",
      });
      setAuditCheckpointList([]);
      setAuditTypeList([]);
    }

    if (name === "audit_checkpoint_id") {
      getAuditTypeList(
        "",
        getValue(request, `region_id`, ""),
        getValue(request, `group_id`, ""),
        getValue(request, `state_id`, ""),
        getValue(request, `city_id`, ""),
        getValue(request, `location_id`, ""),
        getValue(request, `vendor_id`, ""),
        id,
        ""
      );
      setRequest({
        ...request,
        audit_checkpoint_id: "",
        audit_type: "",
      });
      setAuditTypeList([]);
    }

    setRequest({
      ...request,
      [name]: id,
    });
  };


  // const handleSubmitSmartFilter = () => {
  //   const urlSearchParams = new URLSearchParams(window.location.search);
  //   const params = Object.fromEntries(urlSearchParams.entries());
  //   let payload: any = {
  //     ...params,
  //     region_id: getValue(request, `region_id`, ""),
  //     group_id: getValue(request, `group_id`, ""),
  //     location_id: getValue(request, `location_id`, ""),
  //     vendor_id: getValue(request, `vendor_id`, ""),
  //   };
  //   let queryRequest = QueryRequestHelper(payload);
  //   navigate(`${window.location.pathname}?${queryRequest}`);
  //   // handleFilter();
  // };

  // let region_ID =
  //   getValue(regionList, `length`, 0) > 0 &&
  //   regionList.filter(
  //     (item: object) =>
  //       getValue(item, `id`, "") == getValue(request, `region_id`, "")
  //   );

  // let group_ID =
  //   getValue(groupsList, `length`, 0) > 0 &&
  //   groupsList.filter(
  //     (item: object) =>
  //       getValue(item, `id`, "") == getValue(request, `group_id`, "")
  //   );

  // let location_ID =
  //   getValue(locationsList, `length`, 0) > 0 &&
  //   locationsList.filter(
  //     (item: object) =>
  //       getValue(item, `id`, "") == getValue(request, `location_id`, "")
  //   );

  // let vendor_ID =
  //   getValue(vendorsList, `length`, 0) > 0 &&
  //   vendorsList.filter(
  //     (item: object) =>
  //       getValue(item, `id`, "") == getValue(request, `vendor_id`, "")
  //   );  

  const handleSubmitSmartFilter = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      country_id: getValue(request, `country_id`, ""),
      state_id: getValue(request, `state_id`, ""),
      city_id: getValue(request, `city_id`, ""),
      region_id: getValue(request, `region_id`, ""),
      group_id: getValue(request, `group_id`, ""),
      location_id: getValue(request, `location_id`, ""),
      vendor_id: getValue(request, `vendor_id`, ""),
      audit_type: getValue(request, `audit_type`, ""),
      audit_checkpoint_id: getValue(request, `audit_checkpoint_id`, ""),
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  let state_ID =
    getValue(stateList, `length`, 0) > 0 &&
    stateList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `state_id`, "")
    );

  let city_ID =
    getValue(cityList, `length`, 0) > 0 &&
    cityList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `city_id`, "")
    );
  let region_ID =
    getValue(regionList, `length`, 0) > 0 &&
    regionList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `region_id`, "")
    );

  let group_ID =
    getValue(groupsList, `length`, 0) > 0 &&
    groupsList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `group_id`, "")
    );

  let location_ID =
    getValue(locationsList, `length`, 0) > 0 &&
    locationsList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `location_id`, "")
    );

  let vendor_ID =
    getValue(vendorsList, `length`, 0) > 0 &&
    vendorsList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `vendor_id`, "")
    );
    
    let audit_checkpoint_ID =
    getValue(auditCheckpointList, `length`, 0) > 0 &&
    auditCheckpointList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `audit_checkpoint_id`, "")
    );

    let audit_type_ID =
    getValue(auditTypeList, `length`, 0) > 0 &&
    auditTypeList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `audit_type`, "")
    );

  /* -------------------------------------------------------------------------- */
  /*                             Download Reports                               */
  /* -------------------------------------------------------------------------- */
//   const [downloadLoading, setDownloadLoading] = useState(false);
//   const handleDownloadSelfComplianceReport = async () => {
//     const urlSearchParams = new URLSearchParams(window.location.search);
//     const params = Object.fromEntries(urlSearchParams.entries());
//     let selectedIDs: any = urlSearchParams.getAll("smart_filter_tags[]");
//     let dates = params.date ? new Date(params.date) : new Date();
//     var from_date = params.from_date
//       ? params.from_date
//       : new Date(dates.getFullYear(), dates.getMonth(), 1);
//     var to_date = params.to_date
//       ? params.to_date
//       : new Date(dates.getFullYear(), dates.getMonth() + 1, 0);
//     let payload: any = {
//       page_no: params.page_no ? parseInt(params.page_no) : 1,
//       page_size: params.limit ? parseInt(params.limit) : limit,
//       status: getValue(params,`status`,''),
//       sort_by: params.sort_by,
//       // month: params.date
//       //   ? params.date.split("-")[1]
//       //   : date
//       //   ? moment(date).format("MM")
//       //   : moment(dates).format("MM"),
//       // year: params.date
//       //   ? params.date.split("-")[0]
//       //   : date
//       //   ? moment(date).format("YYYY")
//       //   : moment(dates).format("YYYY"),
//       date_range: [
//         {
//           month: params.date
//           ? parseInt(params.date.split("-")[1])  // Ensuring month is an integer
//           : date
//           ? parseInt(moment(date).format("MM"))
//           : parseInt(moment(dates).format("MM")),  
//           year: params.date
//             ? params.date.split("-")[0]
//             : date
//             ? moment(date).format("YYYY")
//             : moment(dates).format("YYYY")
//         }
//       ],    
//         is_redirect: "true",
//         region_id: params.region_id,  
//         group_id: params.group_id,  
//         location_id: params.location_id,
//         state_id: params.state_id,  
//         city_id: params.city_id,  
//         upload_status: params.update_status,
//         vendor_id: params.vendor_id,
//         audit_status: params.audit_type ? params.audit_type : params.audit_status,
//         legislation_rule_id: params.audit_checkpoint_id,
//         event_text: params.event_text,
//         category_of_law_text: params.category_of_law_text,
//         report_type: "VENDOR_AUDIT_COMPLIANCE",
// download_type: downloadType === DownloadTypeEnum.PDF ? DownloadTypeEnum.PDF : DownloadTypeEnum.EXCEL,        report_name: (
//           convertDateAsString(from_date) +
//           " " +
//           "to" +
//           " " +
//           convertDateAsString(to_date)
//         ).toString(),
//     };
//     Object.keys(payload).forEach((key) => {
//       if (!payload[key] || payload[key] === undefined) {
//         delete payload[key];
//       }
//     });
    
//     // let queryRequest = QueryRequestHelper(payload);
//     setDownloadLoading(true);
//     try {
//       let resp = await downloadVendorComplianceMaster(payload);
//       if (resp) {
//         setDownloadLoading(false);
//         toast.success(getValue(resp, `message`, ""));
//         navigate(`/self-compliance-logs/VENDOR_AUDIT_COMPLIANCE`);
//         // handleDownloadOnClick(
//         //   getValue(resp, `data.downloadUrl`, ""),
//         //   "Show Cause Notice Report"
//         // );
//       } else {
//         setDownloadLoading(false);
//       }
//     } catch (error) {
//       setDownloadLoading(false);
//     }
//   };
const [downloadLoading, setDownloadLoading] = useState(false);
  
  // 1. Accept downloadType as a parameter with a default value
  const handleDownloadSelfComplianceReport = async (downloadType: DownloadTypeEnum = DownloadTypeEnum.EXCEL) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let selectedIDs: any = urlSearchParams.getAll("smart_filter_tags[]");
    let dates = params.date ? new Date(params.date) : new Date();
    var from_date = params.from_date
      ? params.from_date
      : new Date(dates.getFullYear(), dates.getMonth(), 1);
    var to_date = params.to_date
      ? params.to_date
      : new Date(dates.getFullYear(), dates.getMonth() + 1, 0);
    let payload: any = {
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: params.limit ? parseInt(params.limit) : limit,
      status: getValue(params,`status`,''),
      sort_by: params.sort_by,
      date_range: [
        {
          month: params.date
          ? parseInt(params.date.split("-")[1])  
          : date
          ? parseInt(moment(date).format("MM"))
          : parseInt(moment(dates).format("MM")),  
          year: params.date
            ? params.date.split("-")[0]
            : date
            ? moment(date).format("YYYY")
            : moment(dates).format("YYYY")
        }
      ],    
        is_redirect: "true",
        region_id: params.region_id,  
        group_id: params.group_id,  
        location_id: params.location_id,
        state_id: params.state_id,  
        city_id: params.city_id,  
        upload_status: params.update_status,
        vendor_id: params.vendor_id,
        audit_status: params.audit_type ? params.audit_type : params.audit_status,
        legislation_rule_id: params.audit_checkpoint_id,
        event_text: params.event_text,
        category_of_law_text: params.category_of_law_text,
        report_type: "VENDOR_AUDIT_COMPLIANCE",
        
        // 2. Dynamically use the parameter value here
        download_type: downloadType === DownloadTypeEnum.PDF ? DownloadTypeEnum.PDF : DownloadTypeEnum.EXCEL,

        report_name: (
          convertDateAsString(from_date) +
          " " +
          "to" +
          " " +
          convertDateAsString(to_date)
        ).toString(),
    };
    Object.keys(payload).forEach((key) => {
      if (!payload[key] || payload[key] === undefined) {
        delete payload[key];
      }
    });
    
    setDownloadLoading(true);
    try {
      let resp = await downloadVendorComplianceMaster(payload);
      if (resp) {
        setDownloadLoading(false);
        toast.success(getValue(resp, `message`, ""));
        navigate(`/self-compliance-logs/VENDOR_AUDIT_COMPLIANCE`);
      } else {
        setDownloadLoading(false);
      }
    } catch (error) {
      setDownloadLoading(false);
    }
  };
  const handleDownloadVendorComplianceAuditScore = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let selectedIDs: any = urlSearchParams.getAll("smart_filter_tags[]");
    let dates = params.date ? new Date(params.date) : new Date();
    var from_date = params.from_date
      ? params.from_date
      : new Date(dates.getFullYear(), dates.getMonth(), 1);
    var to_date = params.to_date
      ? params.to_date
      : new Date(dates.getFullYear(), dates.getMonth() + 1, 0);

    let payload: any = {
      // page_no: params.page_no ? parseInt(params.page_no) : 1,
      // page_size: params.limit ? parseInt(params.limit) : limit,
      status: getValue(params,`status`,''),
      sort_by: params.sort_by,
      month: params.date
      ? parseInt(params.date.split("-")[1]) // Convert month to integer
      : parseInt(moment(dates).format("MM")),
      year: params.date
        ? params.date.split("-")[0] // Keep year as a string
        : moment(dates).format("YYYY"),
  
      // month: params.date
      // ? params.date.split("-")[1]  // Ensuring month is an integer
      // : date
      // ? moment(date).format("MM")
      // : moment(dates).format("MM"),  
      // year: params.date
      //   ? params.date.split("-")[0]
      //   : date
      //   ? moment(date).format("YYYY")
      //   : moment(dates).format("YYYY"),    
        is_redirect: "true",
        // region_id: params.region_id,  
        // group_id: params.group_id,  
        // location_id: params.location_id,
        // state_id: params.state_id,  
        // city_id: params.city_id,  
        // upload_status: params.update_status,
        // vendor_id: params.vendor_id,
        // audit_status: params.audit_status,
        // event_text: params.event_text,
        // category_of_law_text: params.category_of_law_text,
        report_type: "VENDOR_AUDIT_SCORE_SITE",
        report_name: (
          convertDateAsString(from_date) +
          " " +
          "to" +
          " " +
          convertDateAsString(to_date)
        ).toString(),
    };
    Object.keys(payload).forEach((key) => {
      if (!payload[key] || payload[key] === undefined) {
        delete payload[key];
      }
    });
    
    setDownloadLoading(true);
    try {
      let resp = await downloadVendorComplianceAuditScore(payload);
      if (resp) {
        setDownloadLoading(false);
        toast.success(getValue(resp, `message`, ""));
        navigate(`/self-compliance-logs/VENDOR_AUDIT_SCORE_SITE`);
      } else {
        setDownloadLoading(false);
      }
    } catch (error) {
      setDownloadLoading(false);
    }
  };

  const handleDownloadVendorwiseAuditScore = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let selectedIDs: any = urlSearchParams.getAll("smart_filter_tags[]");
    let dates = params.date ? new Date(params.date) : new Date();
    var from_date = params.from_date
      ? params.from_date
      : new Date(dates.getFullYear(), dates.getMonth(), 1);
    var to_date = params.to_date
      ? params.to_date
      : new Date(dates.getFullYear(), dates.getMonth() + 1, 0);

    let payload: any = {
      // page_no: params.page_no ? parseInt(params.page_no) : 1,
      // page_size: params.limit ? parseInt(params.limit) : limit,
      status: getValue(params,`status`,''),
      sort_by: params.sort_by,
      month: params.date
      ? parseInt(params.date.split("-")[1]) // Convert month to integer
      : parseInt(moment(dates).format("MM")),
      year: params.date
        ? params.date.split("-")[0] // Keep year as a string
        : moment(dates).format("YYYY"),  
        is_redirect: "true",
        report_type: "VENDOR_AUDIT_SCORE_VENDOR",
        report_name: (
          convertDateAsString(from_date) +
          " " +
          "to" +
          " " +
          convertDateAsString(to_date)
        ).toString(),
    };
    Object.keys(payload).forEach((key) => {
      if (!payload[key] || payload[key] === undefined) {
        delete payload[key];
      }
    });
    
    setDownloadLoading(true);
    try {
      let resp = await downloadVendorWiseAuditScore(payload);
      if (resp) {
        setDownloadLoading(false);
        toast.success(getValue(resp, `message`, ""));
        navigate(`/self-compliance-logs/VENDOR_AUDIT_SCORE_VENDOR`);
      } else {
        setDownloadLoading(false);
      }
    } catch (error) {
      setDownloadLoading(false);
    }

  }

  // Common View Logs Option
  const [dropdownOptions] = useState([
    { value: "VENDOR_AUDIT_COMPLIANCE", label: "Vendor Checkpoint" },
    { value: "VENDOR_AUDIT_SCORE_SITE", label: "Vendor Audit Score" },
    { value: "VENDOR_AUDIT_SCORE_VENDOR", label: "Vendorwise Audit Score" },
  ]);

  
  const handleNavigateLogs = () => {
    navigate(`/self-compliance-logs/VENDOR_AUDIT_COMPLIANCE`);
  };

  return (
    <>
      <DashboardLayout
        permissions={getValue(props, `tabPermissionList`, [])}
        subTabPermissionList={getValue(props, `subTabPermissionList`, [])}
      >
        {!isLoading &&
        !getValue(props, `subTabPermissionList`, []).includes(
          "repository_vendor_compliance_master"
        ) ? (
          <NoAccessPage />
        ) : (
          <>
            <div className="dashboard-wrapper__header d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <div className="header-parent-icon-holder">
                  <MenuRepositorySvgComponent />
                </div>

                <div className="title-wrapper">
                  <h6 className="dashbaord-wrapper__header-parent-title">
                    Vendor Compliance
                  </h6>
                  <h4 className="dashbaord-wrapper__header-title">Master</h4>
                </div>
              </div>

              <div className="d-flex align-items-center">
                <RightMenuHeaders
                  // Mapped Task FH (Function Head)
                  mappedTasksFH={false}
                  // date range
                  dateRange={false}
                  monthYear={true}
                  value={date}
                  onChange={setDate}
                  handleSubmitDate={handleSubmitDate}
                  allTime={false}
                  //search
                  isSearch={true}
                  searchInput={search_text}
                  showSearchTextbox={showSearchTextbox}
                  toggleSearch={toggleSearch}
                  toggleSearchClose={toggleSearchClose}
                  handleChangeSearch={handleChangeSearch}
                  //smartFilter
                  smartFilter={false}
                  changeOwner={false}
                  //Line Seperator of button
                  lineSeperator={true}
                  // download section
                  // downloadSelfComplianceReport={true}
                  downloadLoading={downloadLoading}
                  // viewDownloadedSelfComplianceReports={true}
                  handleNavigateLogs={handleNavigateLogs}


                  // bulk export
                  vendorComplianceBulkDownload
                  handleDownloadSelfComplianceReport={
                    handleDownloadSelfComplianceReport
                  }
                  handleDownloadVendorComplianceAuditScore={handleDownloadVendorComplianceAuditScore}
                  handleDownloadVendorwiseAuditScore={handleDownloadVendorwiseAuditScore}

                  // // Common View Logs
                  commonViewLogs
                  dropdownOptions={dropdownOptions}
                />
              </div>
            </div>

            <div
            className={`main-page-layout-wrapper has-module-filter`}
            id={
                getValue(selectedIDs, `length`, 0) > 0
                  ? "blueNavigationVisible"
                  : ""
              }
            >

            {/* <div className="filter-section-wrap d-flex align-items-center justify-content-between module-filter-wrapper">
              <div className="width-20">
                <div className="filter-form-wrappper__location-input module_filter_fields_wrapper">
                <label htmlFor="country_id" className="floating-label">
                  Region
                </label>
                  <SearchableDropdownSelect
                    placeholder={`Select Region`}
                    options={regionList}
                    searchLoading={regionLoading}
                    handleChange={(val: any) =>
                      val
                        ? getRegionsList(val, "")
                        : handleRemoveFilter("region_id")
                    }
                    handleClick={(e: any) =>
                      handleSelectFilter(getValue(e, `id`, ""), "region_id")
                    }
                    // value={region_ID}
                    value={
                      Array.isArray(region_ID) && region_ID.length > 0
                        ? region_ID[0]
                        : ""
                    }
                    label="label"
                    id="id"
                    name={"region_id"}
                  />
                </div>
              </div>

              <div className="width-20">
                <div className="filter-form-wrappper__location-input module_filter_fields_wrapper">
                  <label htmlFor="country_id" className="floating-label">
                    Account
                  </label>
                  <SearchableDropdownSelect
                    placeholder={`Select Account`}
                    options={groupsList}
                    searchLoading={groupLoading}
                    handleChange={(val: any) =>
                      val
                        ? getGroupsList(
                            val,
                            getValue(request, `group_id`, ""),
                            ""
                          )
                        : handleRemoveFilter("group_id")
                    }
                    handleClick={(e: any) =>
                      handleSelectFilter(getValue(e, `id`, ""), "group_id")
                    }
                    // value={group_ID}
                    value={
                      Array.isArray(group_ID) && group_ID.length > 0
                        ? group_ID[0]
                        : ""
                    }
                    label="label"
                    id="id"
                    name={"group_id"}
                  />
                </div>
              </div>

              <div className="width-20">
              <div className="filter-form-wrappper__location-input module_filter_fields_wrapper">
                  <label htmlFor="country_id" className="floating-label">
                    Site
                  </label>
                  <SearchableDropdownSelect
                    placeholder={`Select Site`}
                    options={locationsList}
                    searchLoading={locationLoading}
                    handleChange={(val: any) =>
                      val
                        ? getLocationsList(
                            val,
                            getValue(request, `region_id`, ""),
                            getValue(request, `group_id`, ""),
                            // getValue(request, `state_id`, ""),
                            // getValue(request, `city_id`, ""),
                            ""
                          )
                        : handleRemoveFilter("location_id")
                    }
                    handleClick={(e: any) =>
                      handleSelectFilter(getValue(e, `id`, ""), "location_id")
                    }
                    // value={location_ID}
                    value={
                      Array.isArray(location_ID) && location_ID.length > 0
                        ? location_ID[0]
                        : ""
                    }
                    x
                    label="label"
                    id="id"
                    name={"location_id"}
                    // removeClose
                  />
                </div>
              </div>

              <div className="width-20">
              <div className="filter-form-wrappper__location-input module_filter_fields_wrapper">
                  <label htmlFor="country_id" className="floating-label">
                  Vendor
                  </label>                    
                  <SearchableDropdownSelect
                    placeholder={`Select Vendor`}
                    options={vendorsList}
                    searchLoading={vendorLoading}
                    handleChange={(val: any) =>
                      val
                        ? getVendorList(
                            val,
                            getValue(request, `region_id`, ""),
                            getValue(request, `group_id`, ""),
                            // getValue(request, `state_id`, ""),
                            // getValue(request, `city_id`, ""),
                            getValue(request, `location_id`, ""),
                            ""
                          )
                        : handleRemoveFilter("vendor_id")
                    }
                    handleClick={(e: any) =>
                      handleSelectFilter(getValue(e, `id`, ""), "vendor_id")
                    }
                    value={
                      Array.isArray(vendor_ID) && vendor_ID.length > 0
                        ? vendor_ID[0]
                        : ""
                    }
                    label="label"
                    id="id"
                    name={"vendor_id"}
                    // removeClose
                    disabled={props.disableVendor}
                  />
                </div>
              </div>

              <div className="width-18">
                <div className="filter-form-wrappper__cta-wrapper">
                  <button
                    className="filter-form-wrappper__cta-btn filter-form-wrappper__cta-btn--search btn btn-primary"
                    onClick={handleSubmitSmartFilter}
                  >
                    Search
                  </button>
                    <button
                      className="filter-form-wrappper__cta-btn filter-form-wrappper__cta-btn--reset btn"
                      onClick={reset}
                    >
                      Reset
                    </button>
                </div>
              </div>
            </div> */}

                <div className="filter-section-wrap module-filter-wrapper">
                  <div className="width-20">
                    <div className="filter-form-wrappper__location-input module_filter_fields_wrapper">
                      <label htmlFor="country_id" className="floating-label">
                        Region
                      </label>
                      <SearchableDropdownSelect
                        placeholder={`Select Region`}
                        options={regionList}
                        searchLoading={regionLoading}
                        handleChange={(val: any) =>
                          val
                            ? getRegionsList(val, "")
                            : handleRemoveFilter("region_id")
                        }
                        handleClick={(e: any) =>
                          handleSelectFilter(getValue(e, `id`, ""), "region_id")
                        }
                        // value={region_ID}
                        value={
                          Array.isArray(region_ID) && region_ID.length > 0
                            ? region_ID[0]
                            : ""
                        }
                        label="label"
                        id="id"
                        name={"region_id"}
                      />
                    </div>
                  </div>

                  <div className="width-20">
                    <div className="filter-form-wrappper__location-input module_filter_fields_wrapper">
                      <label htmlFor="country_id" className="floating-label">
                        Account
                      </label>
                      <SearchableDropdownSelect
                        placeholder={`Select Account`}
                        options={groupsList}
                        searchLoading={groupLoading}
                        handleChange={(val: any) =>
                          val
                            ? getGroupsList(
                                val,
                                getValue(request, `group_id`, ""),
                                ""
                              )
                            : handleRemoveFilter("group_id")
                        }
                        handleClick={(e: any) =>
                          handleSelectFilter(getValue(e, `id`, ""), "group_id")
                        }
                        // value={group_ID}
                        value={
                          Array.isArray(group_ID) && group_ID.length > 0
                            ? group_ID[0]
                            : ""
                        }
                        label="label"
                        id="id"
                        name={"group_id"}
                      />
                    </div>
                  </div>

                  <div className="width-20">
                    <div className="filter-form-wrappper__location-input module_filter_fields_wrapper">
                      <label htmlFor="country_id" className="floating-label">
                        State
                      </label>
                      <SearchableDropdownSelect
                        placeholder={`Choose State`}
                        options={stateList}
                        searchLoading={stateLoading}
                        handleChange={(val: any) =>
                          val
                            ? getStatesList(
                                val,
                                getValue(request, `region_id`, ""),
                                getValue(request, `group_id`, ""),
                                // getValue(props, `request.state_id`, ""),
                                ""
                              )
                            : handleRemoveFilter("state_id")
                        }
                        handleClick={(e: any) =>
                          handleSelectFilter(
                            getValue(e, `id`, ""),
                            "state_id"
                          )
                        }
                        value={Array.isArray(state_ID) && state_ID.length > 0
                          ? state_ID[0]
                          : ""
                        }
                        label="label"
                        id="id"
                        name={"state_id"}
                      />                    
                      </div>
                  </div>

                  <div className="width-20">
                    <div className="filter-form-wrappper__location-input module_filter_fields_wrapper">
                      <label htmlFor="country_id" className="floating-label">
                        City
                      </label>
                        <SearchableDropdownSelect
                          placeholder={`Choose City`}
                          options={cityList}
                          searchLoading={cityLoading}
                          handleChange={(val: any) =>
                            val
                              ? getCitiesList(
                                  val,
                                  getValue(request, `region_id`, ""),
                                  getValue(request, `group_id`, ""),
                                  getValue(request, `state_id`, ""),
                                  // getValue(props, `request.city_id`, ""),
                                  ""
                                )
                              : handleRemoveFilter("city_id")
                          }
                          handleClick={(e: any) =>
                            handleSelectFilter(
                              getValue(e, `id`, ""),
                              "city_id"
                            )
                          }
                          // value={getValue(props, `city_ID[${0}]`, "")}
                          value={Array.isArray(city_ID) && city_ID.length > 0
                            ? city_ID[0]
                            : ""
                          }
                          label="label"
                          id="id"
                          name={"city_id"}
                        />              
                      </div>
                  </div>

                  <div className="width-20">
                    <div className="filter-form-wrappper__location-input module_filter_fields_wrapper">
                      <label htmlFor="country_id" className="floating-label">
                        Site
                      </label>
                      <SearchableDropdownSelect
                        placeholder={`Select Site`}
                        options={locationsList}
                        searchLoading={locationLoading}
                        handleChange={(val: any) =>
                          val
                            ? getLocationsList(
                                val,
                                getValue(request, `region_id`, ""),
                                getValue(request, `group_id`, ""),
                                getValue(request, `state_id`, ""),
                                getValue(request, `city_id`, ""),
                                ""
                              )
                            : handleRemoveFilter("location_id")
                        }
                        handleClick={(e: any) =>
                          handleSelectFilter(
                            getValue(e, `id`, ""),
                            "location_id"
                          )
                        }
                        // value={location_ID}
                        value={
                          Array.isArray(location_ID) && location_ID.length > 0
                            ? location_ID[0]
                            : ""
                        }
                        x
                        label="label"
                        id="id"
                        name={"location_id"}
                        // removeClose
                      />
                    </div>
                  </div>

                  <div className="width-20">
                    <div className="filter-form-wrappper__location-input module_filter_fields_wrapper">
                      <label htmlFor="country_id" className="floating-label">
                        Vendor
                      </label>
                      <SearchableDropdownSelect
                        placeholder={`Select Vendor`}
                        options={vendorsList}
                        searchLoading={vendorLoading}
                        handleChange={(val: any) =>
                          val
                            ? getVendorList(
                                val,
                                getValue(request, `region_id`, ""),
                                getValue(request, `group_id`, ""),
                                getValue(request, `state_id`, ""),
                                getValue(request, `city_id`, ""),
                                getValue(request, `location_id`, ""),
                                ""
                              )
                            : handleRemoveFilter("vendor_id")
                        }
                        handleClick={(e: any) =>
                          handleSelectFilter(getValue(e, `id`, ""), "vendor_id")
                        }
                        value={
                          Array.isArray(vendor_ID) && vendor_ID.length > 0
                            ? vendor_ID[0]
                            : ""
                        }
                        label="label"
                        id="id"
                        name={"vendor_id"}
                        // removeClose
                        disabled={props.disableVendor}
                      />
                    </div>
                  </div>

                  <div className="width-20">
                    <div className="filter-form-wrappper__location-input module_filter_fields_wrapper">
                      <label htmlFor="country_id" className="floating-label">
                        Audit Checkpoint
                      </label>
                      <SearchableDropdownSelect
                        placeholder={`Select Audit Checkpoint`}
                        options={auditCheckpointList}
                        searchLoading={auditCheckpointLoading}
                        handleChange={(val: any) =>
                          val
                            ? getAuditCheckpointList(
                                val,
                                getValue(request, `region_id`, ""),
                                getValue(request, `group_id`, ""),
                                getValue(request, `state_id`, ""),
                                getValue(request, `city_id`, ""),
                                getValue(request, `location_id`, ""),
                                getValue(request, `vendor_id`, ""),
                                ""
                              )
                            : handleRemoveFilter("audit_checkpoint_id")
                        }
                        handleClick={(e: any) =>
                          handleSelectFilter(getValue(e, `id`, ""), "audit_checkpoint_id")
                        }
                        value={
                          Array.isArray(audit_checkpoint_ID) && audit_checkpoint_ID.length > 0
                            ? audit_checkpoint_ID[0]
                            : ""
                        }
                        label="label"
                        id="id"
                        name={"audit_checkpoint_ID"}
                        // removeClose
                        disabled={props.disableVendor}
                      />
                    </div>
                  </div>

                  <div className="width-20">
                    <div className="filter-form-wrappper__location-input module_filter_fields_wrapper">
                      <label htmlFor="country_id" className="floating-label">
                        Audit Status
                      </label>
                      
                      <SearchableDropdownSelect
                        placeholder={`Choose Audit Status`}
                        options={auditTypeList}
                        searchLoading={auditTypeLoading}
                        handleChange={(val: any) =>
                          val
                            ? getAuditTypeList(
                                val,
                                getValue(request, `region_id`, ""),
                                getValue(request, `group_id`, ""),
                                getValue(request, `state_id`, ""),
                                getValue(request, `city_id`, ""),
                                getValue(request, `location_id`, ""),
                                getValue(request, `vendor_id`, ""),
                                getValue(request, `audit_checkpoint_id`, ""),
                                ""
                              )
                            : handleRemoveFilter("audit_type")
                        }
                        handleClick={(e: any) =>
                          handleSelectFilter(
                            getValue(e, `id`, ""),
                            "audit_type"
                          )
                        }
                        // value={getValue(props, `audit_type_ID[${0}]`, "")}
                        value={Array.isArray(audit_type_ID) && audit_type_ID.length > 0
                          ? audit_type_ID[0]
                          : ""}
                        label="label"
                        id="id"
                        name={"audit_type"}
                        // removeClose
                      />
                    </div>
                  </div>

                  {/* <div className="width-20">
                    <div className="filter-form-wrappper__location-input module_filter_fields_wrapper">
                      <label htmlFor="country_id" className="floating-label">
                        Status
                      </label>
                      <InputField
                          inputType="INPUT_REACT_SELECT_MODAL"
                          placeholder="Choose Status"
                          className="form-control w-100"
                          options={complianceStatusList}
                          value={complianceStatusList.find(
                            (item: object) =>
                              getValue(params, `audit_status`, "") ===
                              getValue(item, `value`, "")
                          )}
                          onChange={(e: any) =>
                            handleNavigateFilter(getValue(e, `value`, ""))
                          }
                          label="Country"
                          isClear
                          customClass="module_filter_dropdown_wrapper"
                        />
                    </div>
                  </div> */}

                  <div className="width-18">
                    <div className="filter-form-wrappper__cta-wrapper">
                      <button
                        className="filter-form-wrappper__cta-btn filter-form-wrappper__cta-btn--search btn btn-primary"
                        onClick={handleSubmitSmartFilter}
                      >
                        Search
                      </button>
                      <button
                        className="filter-form-wrappper__cta-btn filter-form-wrappper__cta-btn--reset btn"
                        onClick={reset}
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                </div>

                <hr />


              <div className="admin-wrapper position-relative">
                {isLoading || !props.permissionAPITriggered ? (
                  <Loader />
                ) : list.length > 0 ? (
                  <ScrollableReactTable
                    columns={columns}
                    data={list}
                    getTableState={getTableState}
                    rowClick={rowClick}
                    checkboxlogo
                    check={check}
                    selectedIDs={selectedIDs}
                    getTrProps={getTrProps}
                  />
                ) : (
                  <>
                    {Object.keys(params).length !== 0 ? (
                      <>
                        <CheckpointMasterNotfound />
                      </>
                    ) : (
                      <CheckpointMasterNotfound />
                    )}
                  </>
                )}
              </div>
              <FooterWrapper
                list={list}
                totalCount={totalCount}
                limit={limit}
                page_no={page_no}
                handleChangePagination={handleChangePagination}
                handleChangeLimit={handleChangeLimit}
              />{" "}
            </div>
          </>
        )}
      </DashboardLayout>
    </>
  );
}
